// @flow
import {combineReducers} from 'redux';
import {rateBlockReducer} from './rate-block';
import type {TRateBlockState} from './rate-block';

const reducers = {
    rateBlock: rateBlockReducer,
};

type TRateBlockModuleState = {
    rateBlock: TRateBlockState,
};

const rateBlockModuleReducer = combineReducers(reducers);
export {rateBlockModuleReducer};
export type {TRateBlockModuleState};
